module.exports = __webpack_public_path__ + "static/ranking-list.96a00642.png";